/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BusinessObjectDefinitionDescriptionSuggestionKey } from './businessObjectDefinitionDescriptionSuggestionKey';


export interface BusinessObjectDefinitionDescriptionSuggestion { 
    /**
     * A system unique ID of this business object definition description suggestion
     */
    id?: number;
    businessObjectDefinitionDescriptionSuggestionKey: BusinessObjectDefinitionDescriptionSuggestionKey;
    /**
     * The description suggestion
     */
    descriptionSuggestion?: string;
    /**
     * The status of the business object definition description suggestion. One of the following values: PENDING, ACCEPTED                
     */
    status?: string;
    /**
     * The User ID of the user who created this business object definition description suggestion
     */
    createdByUserId?: string;
    /**
     * The timestamp when this business object definition description suggestion was created on
     */
    createdOn?: Date;
}
